export const mockNotificationsServerResponse = {
    offers: {
        offerToReview: [
            {
                offerId: 73256,
                propertyId: 140882,
                toLet: false,
                propertyAddress: '7834',
                buyerName: 'Miss julia harris',
                propertyRegionType: null,
            },
        ],
        updateToOffer: [
            {
                offerId: 259873,
                propertyId: 121057,
                toLet: false,
                propertyAddress: '19',
                buyerName: 'Miss ipekukbuyer ipekukbuyer',
                propertyRegionType: null,
            },
        ],
        lawyerDetailsRequired: [],
        payReferencingFee: [],
        submitReferencing: [],
        id: '268990',
        lastUpdated: '2020-07-01T08:42:41Z',
    },
    viewings: {
        outcomeOfViewing: [
            {
                viewingId: 687023,
                propertyId: 276982,
                propertyAddress: '410',
            },
        ],
        id: '268990',
        lastUpdated: '2020-06-22T17:43:47Z',
    },
    diary: {
        appointmentInDiary: [
            {
                appointmentId: 691271,
                propertyId: 152106,
                appointmentDateTime: '2020-07-04T08:00:00Z',
            },
        ],
        id: '268990',
        lastUpdated: '2020-07-01T14:18:53Z',
    },
    messages: {
        unreadMessage: [
            {
                messageId: 22633,
                propertyId: 0,
                from: 'Pratibha Sistla',
            },
        ],
        id: '268990',
        lastUpdated: '2020-07-27T12:52:00Z',
    },
    feedback: {
        provideFeedback: [],
        feedbackToReview: [],
        id: '268990',
        lastUpdated: '2018-08-13T09:22:00Z',
    },
};
export const mockFormattedNotificationServerResponse = [
    {
        area: 'messages',
        type: 'unreadMessage',
        lastUpdated: '2020-07-27T12:52:00Z',
        copy: 'You have an unread message from Pratibha Sistla',
        url: 'https://qa.pbr.so/messages',
    },
    {
        area: 'diary',
        type: 'appointmentInDiary',
        lastUpdated: '2020-07-01T14:18:53Z',
        copy: 'Appointment confirmation required for 4th July 2020',
        url: 'https://qa.pbr.so/seller#!manageDiary?date=2020-07-04',
    },
    {
        area: 'offers',
        type: 'offerToReview',
        lastUpdated: '2020-07-01T08:42:41Z',
        copy: "You've received a new offer!",
        url: 'https://qa.pbr.so/seller#!manageOffers?offerid=73256',
    },
    {
        area: 'offers',
        type: 'updateToOffer',
        lastUpdated: '2020-07-01T08:42:41Z',
        copy: "You've received an updated offer!",
        url: 'https://qa.pbr.so/seller#!manageOffers?offerid=259873',
    },
    {
        area: 'viewings',
        type: 'outcomeOfViewing',
        lastUpdated: '2020-06-22T17:43:47Z',
        copy: 'Please confirm if your previous viewing was attended',
        url: 'https://qa.pbr.so/seller#!manageViewings?viewingid=687023',
    },
];
